<template>
  <div class="audiointro">
    <button class="skip" @click="skipAudio"></button>
    <canvas ref="oscilloscope"></canvas>
  </div>
</template>

<script>
import {Howl, Howler} from 'howler';
import axios from 'axios';

export default {
  name: 'AudioIntro',
  props: ['userData', 'stationData'],
  data: () => {
    return {
      currentWaveform: []
    }
  },
  mounted() {
    this.initAudio();
    this.initWaves();
      this.soundVoice.play();
    window.setTimeout(() => {
    }, 1000);
    // console.log(this.stationData.intro_track);
  },
  methods: {
    skipAudio() {
      this.soundVoice.stop();
      this.$emit('navigate', 'Newsletter');
    },
    initAudio() {
      if(!this.stationData) return;
      this.soundVoice = new Howl({
        src: [this.stationData.intro_track],
        autoplay: false
      });
      
      this.soundVoice.on('end', () => {
        this.$emit('navigate', 'Newsletter');
      });
    },
   initWaves() {
      const analyser = Howler.ctx.createAnalyser();
      
      Howler.masterGain.connect(analyser);

      const waveform = new Float32Array(analyser.frequencyBinCount);
      analyser.getFloatTimeDomainData(waveform);
      analyser.smoothingTimeConstant = 1;
      
      const scale = window.devicePixelRatio;
      const $spectroel = this.$el;
      const $canvas = this.$refs.oscilloscope;

      const ctx = $canvas.getContext('2d');
      const rect = $spectroel.getBoundingClientRect();
      
      $canvas.width = rect.width * scale;
      $canvas.height = rect.height * scale;

      ctx.scale(scale, scale);
      ctx.fillStyle='#FFFDF9';

      const waveScaleRatio = rect.width / waveform.length;
      const zoomFactor = 8;

      const draw = (waveform) => {
        requestAnimationFrame(() => {
          draw(waveform);
        });
        analyser.getFloatTimeDomainData(waveform);
        ctx.clearRect(0, 0, $canvas.width, $canvas.height);
        
        ctx.beginPath();
        ctx.moveTo(0, 0);
        let lastX = 0;

        for(let i = 0; i < waveform.length; i++) {
          if(!this.currentWaveform[i]) this.currentWaveform[i] = 0;
          this.currentWaveform[i] += (waveform[i] - this.currentWaveform[i]) / 5;
          const x = i * waveScaleRatio * zoomFactor;
          const y = ( .2 + (this.currentWaveform[i]) * 1) * window.innerHeight;
          ctx.lineTo(x, y);
          lastX = x;
        }

        ctx.lineTo(lastX, 0);
        ctx.fill();
      }

      draw(waveform);
    },
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">

.audiointro {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;  
}
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // transform: translateY(-20%);
  // animation: canvas-slide 1s cubic-bezier(0.230, 1.000, 0.320, 1.000) .5s 1 forwards;
}
.skip {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: none;
  border: none;
  width: 100%;
  height: 5rem;
  &:focus { outline: none; }
}

@keyframes canvas-slide {
  from {
    // transform: translateY(-20%);
    opacity: 0;
  }
  to {
    // transform: translateY(0);
    opacity: 1;
  }
}

</style>
